import { render } from "./grapesView.vue?vue&type=template&id=675a4da4&scoped=true"
import script from "./grapesView.vue?vue&type=script&lang=js"
export * from "./grapesView.vue?vue&type=script&lang=js"

import "./grapesView.vue?vue&type=style&index=0&id=675a4da4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675a4da4"]])

export default __exports__